import styled from "styled-components";
import { useMobile } from "../../utils/mobile";
import { useTranslation } from "react-i18next";

const Textarea = styled.textarea(
  ({ startImg, isRtl, theme, isMobile, hasError }) => ({
    borderRadius: 10,
    padding: isMobile ? 12 : "10px 20px",
    textIndent: 14,
    fontSize: 16,
    marginTop: isMobile && 0,
    backgroundImage: `url(${startImg})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: isRtl ? "97% 11px" : "3% 11px",
    width: "100%",
    resize: "none",
    "&::placeholder": {
      color: "#AFB4B1",
    },
    paddingInlineStart: startImg && 22,
    border: hasError
      ? `1px solid ${theme.color.error}`
      : `1px solid ${theme.color.darkGray}`,
  })
);

const LabelMobile = styled("div")(({ theme, color, valid }) => ({
  fontSize: 13,
  color: valid === false ? theme.color.error : color || theme.color.label,
  fontWeight: 600,
  letterSpacing: 0.32,
  textAlign: "start",
  position: "relative",
  top: 8,
  backgroundColor: "#FFFFFF",
  width: `fit-content`,
  paddingInline: 6,
  marginInlineStart: 10,
  lineHeight: "12px",
}));

const TextAreaContainer = styled.div(() => ({
  flex: 1,
  textAlign: "start",
}));

const Label = styled.div(({ theme }) => ({
  fontSize: 20,
  color: theme.color.label,
  textAlign: "start",
  fontWeight: 600,
  marginBottom: 5,
}));

const Error = styled("div")`
  color: red;
  font-size: 12px;
`;

const TextArea = ({
  label,
  cols,
  rows,
  name,
  onChange,
  onBlur,
  placeholder,
  startImg,
  helperText,
  ...props
}) => {
  const isMobile = useMobile();
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  return (
    <TextAreaContainer style={{ ...props.style }}>
      {!!label && !isMobile && <Label>{label}</Label>}
      {isMobile && !!label && !!props.value && (
        <LabelMobile startImg={startImg}>{label}</LabelMobile>
      )}
      <Textarea
        isRtl={isRtl}
        value={props.value}
        placeholder={placeholder}
        name={name}
        rows={rows}
        cols={cols}
        isMobile={isMobile}
        onChange={onChange}
        startImg={startImg}
        onBlur={onBlur}
        hasError={!!helperText}
      />
      {!!helperText && <Error>{helperText}</Error>}
    </TextAreaContainer>
  );
};

export default TextArea;
